module.exports = __webpack_public_path__ + "img/3.0096c666.png";